import { NucleusError } from '@nucleus/ncu-error';

export class UnableToParseError extends NucleusError {
  override name = 'UnableToParseError';
}
